const getIndicativeFulfilment = ({ indicativeVariantId, variants }) => {
  const {
    seller = null,
    source = null,
    showShippedByMessage = true
  } = variants.find(({ id }) => id === indicativeVariantId) || {};

  return { seller, source, showShippedByMessage };
};

export default getIndicativeFulfilment;
